import { useTranslation } from "react-i18next";
import { useShowreelItems } from "../../../store/adminDataStore";

export default function StorytellingSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language?.split("-")[0] ?? "en") as "zh" | "en" | "ja";
  // portfolio_items where is_showreel = true AND is_published = true
  const showreelItems = useShowreelItems();

  return (
    <section className="bg-[#F7F6F3] py-20 lg:py-28 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Left — Quote */}
          <div className="relative">
            <div className="absolute -left-4 top-0 bottom-0 flex items-center">
              <span
                className="text-xs uppercase tracking-[0.5em] text-[#C8B8A6] font-light origin-center"
                style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
              >
                {t("tabifoto.storytelling.label")}
              </span>
            </div>
            <div className="pl-8">
              <div className="w-8 h-px bg-[#C8B8A6] mb-8" />
              <blockquote
                className="text-2xl lg:text-3xl xl:text-4xl font-extralight text-[#2C2C2C] leading-relaxed mb-8"
                style={{ letterSpacing: "-0.01em" }}
              >
                &ldquo;{t("tabifoto.storytelling.quote")}&rdquo;
              </blockquote>
              <p className="text-sm text-[#2C2C2C]/50 font-light leading-relaxed max-w-md">
                {t("tabifoto.storytelling.body")}
              </p>
            </div>
          </div>

          {/* Right — Showreel images from portfolio_items (is_showreel + is_published) */}
          <div className="flex flex-col gap-4">
            {showreelItems.map((item) => (
              <div
                key={item.id}
                className="overflow-hidden rounded-lg"
                style={{ border: "1px solid #C8B8A6" }}
              >
                <img
                  src={item.thumbnail_url}
                  alt={item.title}
                  title={item[`description_${lang}`] || item.title}
                  className="w-full h-44 object-cover object-top opacity-90 hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
